<template>
  <div class="create-post-comp">
    <div class="d-flex align-items-center mb-5 mob-shadow">
      <font-awesome-icon :icon="['far', 'arrow-left']" class="cp gray400 mr-4" @click="changeScreen('back')" />
      <h4 class="fw700 font24 gray700 ml-1 mb-0">Add tags</h4>
      <font-awesome-icon :icon="['fal', 'times']" class="font-black ml-auto cp font20" @click="hide" />
    </div>
    <div class="position-relative mb-3">
      <font-awesome-icon :icon="['fal', 'search']" class="position-absolute search-icon gray400 font20" />
      <a-select
        :size="'large'"
        :show-arrow="true"
        v-model="selectedTags"
        show-search
        mode="multiple"
        :filter-option="false"
        placeholder="Search tags"
        class="w-100 tagsSelect sideEffectSelect"
        @search="handleSearchTags"
      >
        <a-select-option v-if="loading" :key="0" :disabled="true">
          <span> <a-spin size="small" class="mr-2" /> Loading... </span>
        </a-select-option>
        <template v-else>
          <a-select-option v-for="tag in allTags" :key="tag" :value="tag">
            {{ tag }}
          </a-select-option>
        </template>
      </a-select>
    </div>
    <div class="tagsContainer">
      <div v-for="tag in selectedTags" :key="tag" class="d-flex align-items-center p-3 bg-gray50 rounded fw700 gray500 font14 mt-2">
        {{ tag }}
        <font-awesome-icon :icon="['fas', 'trash']" class="ml-auto error300 cp" @click="handleDeleteTag(tag)" />
      </div>
    </div>
    <div
      class="br6 p1224 font-white fw700 font14 cp mt-3"
      @click="changeScreen('add', 'tag', selectedTags)"
      :style="{ background: getPrimaryColor(), width: 'fit-content', 'margin-left': 'auto !important' }"
    >
      Done
    </div>
  </div>
</template>

<script>
import axios from "axios"

export default {
  name: "TagsScreen",
  props: { changeScreen: Function, hide: Function, prevSelectedTags: Array },
  data() {
    return { allTags: [], selectedTags: [], loading: false }
  },
  created() {
    this.handleSearchTags("")
  },
  mounted() {
    this.handleSearchTags("")
  },
  watch: {
    prevSelectedTags: {
      handler(v) {
        this.selectedTags = v
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    handleDeleteTag(val) {
      this.selectedTags = this.selectedTags.filter(t => t !== val)
    },
    handleSearchTags(value) {
      this.loading = true
      axios
        .get(`${process.env.SSO_BASE_URL}/api/v2/expert/hashtags/?exclude_followed=True&ordering=-number_of_usage&page_size=10&query=${value}`, {
          headers: { Authorization: `Basic ${btoa("dovemed:dovemed-rules")}` },
        })
        .then(res => {
          this.allTags = res.data.results.map(t => t.name)
          this.loading = false
        })
        .catch(e => {
          this.loading = false
        })
    },
  },
}
</script>

<style lang="scss" scoped>
@media screen and (max-width: 600px) {
  .position-relative {
    flex-grow: 0 !important;
  }
  .search-icon {
    transform: translateY(-50%);
  }
}
.tagsContainer {
  max-height: 50vh;
  overflow: auto;
}
::-webkit-scrollbar {
  width: 5px;
}
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px #e2e8f0;
  border-radius: 10px;
}
::-webkit-scrollbar-thumb {
  background: #2a71d4;
  border-radius: 10px;
}
.search-icon {
  left: 18px;
  z-index: 1;
  transform: translateY(-60%);
  top: 50%;
}
</style>



// WEBPACK FOOTER //
// src/components/home/createNewPost/Tags.vue